import { Environment } from './environment.interface';

export const environment: Environment = {
    production: true,
    env: "qa",
    baseUrl: "https://smqa.instecservices.com",
    applicationEndpoint: "https://smqa-api.instecservices.com",
    syncHost: "https://smqa-sync.instecservices.com",
    documentationUrl: "https://smqa-api-portal.instecservices.com",
    access_token: "",
    applicationInsights: "InstrumentationKey=921d1436-1932-4496-b4ff-2c4ae844a3a1;IngestionEndpoint=https://eastus-4.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/",
    auth: {
        authUri: "https://instecdev.auth0.com",
        clientId: "M8n29JVcoah5eR6sZNn8roIjKrYWN33G",
    },
    altLoginEnabled: "",
    altAuth: {
        authUri: "",
        clientId: ""
    },
    qlik: {
        authUrl: "https://insuritybi.dev.insurity.com/sure-uw/hub/",
        reportsUrl: "https://insuritybi.dev.insurity.com/sure-uw/sense/app/3c9151cd-2cce-42cc-b2d3-d92bba3023fd/sheet/681cc4bf-2fea-402e-af05-3e49d7b19ca6"
    },
    thoughtspot: {
        host: "https://insurity.thoughtspot.cloud"
    },
    ikcDocumentationUrl: "https://docs.insurity.com/category/insurityunderwriting",
    ikcIntegrationDocumentationUrl: "https://docs.insurity.com/bundle/SureUnderwritingUserHelp/page/webhooks.html",
    ikcBureauUrl: "https://docs.insurity.com/bundle/SureCommercialPolicy",
    requireAPIM: true,
    scpAuthClientId: "",
    ApiUrl: '',
    SaaS: true,
    SubscriptionKey: "",
    amplitude: {
        enabled: JSON.parse("true"),
        apiKey: "4880c04fc739e76053a1e13e2bbe4408",
    }
};
